<template>
  <div v-if="source" ref="el" class="z-[1001]" :style="{ ...floatingStyles, maxWidth }">
    <Transition
      appear
      enter-active-class="ease-out duration-150 transform trasition"
      enter-from-class="opacity-0 transform -translate-y-8 scale-50"
      leave-active-class="ease-in duration-150 transform trasition"
      leave-to-class="opacity-0 transform -translate-y-8 scale-50"
      @after-leave="onDissapear"
    >
      <div v-if="visible" v-bind="$attrs">
        <slot></slot>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/vue'
import { onClickOutside } from '@vueuse/core'

import type { Placement } from '@floating-ui/vue'

defineOptions({ inheritAttrs: false })

const model = defineModel({
  type: Boolean
})

const { show = false, placement, source, maxWidth, offsetY = 10, closeOnClickOutside = true } = defineProps<{
  show?: boolean
  placement?: Placement
  source: any
  maxWidth?: string | number | null
  offsetY?: number
  closeOnClickOutside?: boolean
}>()

const el = ref()
const emit = defineEmits(['closed'])
const shouldClose = ref(false)

const visible = computed(() => (show || model.value) && !shouldClose.value)

const { floatingStyles } = useFloating(ref(source), el, {
  // transform: false,
  placement: placement || 'bottom-end',
  middleware: [offset(offsetY), flip(), shift()],
  whileElementsMounted: autoUpdate,
  strategy: 'fixed'
})

const onDissapear = () => {
  shouldClose.value = false
  model.value = false
  emit('closed')
}

const close = () => {
  shouldClose.value = true
}

onClickOutside(el, () => {
  if (!closeOnClickOutside || !visible.value) return
  close()
})

defineExpose({
  close
})
</script>
